import { render, staticRenderFns } from "./VoidForm.vue?vue&type=template&id=54cff93d"
import script from "./VoidForm.vue?vue&type=script&lang=js"
export * from "./VoidForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports